import { render, staticRenderFns } from "./SaveBuildingPart.vue?vue&type=template&id=329c3f83&scoped=true&"
import script from "./SaveBuildingPart.vue?vue&type=script&lang=js&"
export * from "./SaveBuildingPart.vue?vue&type=script&lang=js&"
import style0 from "./SaveBuildingPart.vue?vue&type=style&index=0&id=329c3f83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329c3f83",
  null
  
)

export default component.exports